import { useLayoutEffect, useState, useEffect } from 'react';

export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

export const useScrollY = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    function handleScroll() {
      setScrollY(window.scrollY)
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return scrollY
}

export const useMousePosition = () => {
  const [mouse, setMouse] = useState([0, 0]);

  useEffect(() => {
    function handleMouse(e) {
      setMouse([e.x, e.y])
    }

    window.addEventListener('mousemove', handleMouse);
    return () => window.removeEventListener('mousemove', handleMouse);
  }, [])
  return mouse
}

export const camelCaseToString = camel => {
  return camel.replace(/([A-Z])/g, ' $1')
}